import { Box } from '@chakra-ui/react';
import { FunctionComponent } from 'react';
import Previews from 'components/Content/Previews/constants';

function DashboardContainerPreview({ formValues: rawFormValues, isEditMode }: PreviewComponentProps) {
  const formValues = rawFormValues as ContentContainer;
  const PreviewComponent: FunctionComponent<PreviewComponentProps> | undefined = Previews[formValues?.kind ?? ''];

  return (
    <Box padding="24px 16px 32px 16px">
      {PreviewComponent ? <PreviewComponent formValues={formValues} isEditMode={isEditMode} /> : null}
    </Box>
  );
}

export default DashboardContainerPreview;
